/**
 * Created by Karol Kluska on 15.12.17.
 */

angular
  .module('app')
  .directive('map', Map);

function Map() {
  return {
    restrict: 'E',
    scope: {
      x: '=',
      y: '=',
      d: '='
    },
    template: '<div id="gmaps" style="width:100%; height:450px;"></div>',
    replace: true,
    link: function (scope, element) {
      var map;
      var infoWindow;
      var markers = [];

      var mapOptions = {
        center: new google.maps.LatLng(scope.x, scope.y),
        zoom: scope.d,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        scrollwheel: false
      };

      if (angular.isUndefined(map)) {
        map = new google.maps.Map(element[0], mapOptions);
      }

      setMarker(map, new google.maps.LatLng(scope.x, scope.y), '', '');

      function setMarker(map, position, title, content) {
        var marker;
        var markerOptions = {
          position: position,
          map: map,
          title: title,
          icon: 'https://maps.google.com/mapfiles/ms/icons/green-dot.png'
        };

        marker = new google.maps.Marker(markerOptions);
        markers.push(marker); // add marker to array

        google.maps.event.addListener(marker, 'click', function () {
          if (angular.isDefined(infoWindow)) {
            infoWindow.close();
          }

          var infoWindowOptions = {
            content: content
          };
          infoWindow = new google.maps.InfoWindow(infoWindowOptions);
          infoWindow.open(map, marker);
        });
      }
    }
  };
}
